import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate, useLocation } from 'react-router-dom';
import httpClient from '../../httpClient';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import LinearProgress from '@mui/material/LinearProgress'
import { Skeleton } from '@mui/material';
import {Stack} from '@mui/material';
import tick from '../../assets/tick.svg';


const Batch = ({ batch_id, ...props }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [batch_list_data, set_batch_list_data] = useState(null);
  const [searchKey, setSearchKey] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const [type_id, settype_id] = useState('');
  let [BATCH_COUNT,setBATCH_COUNT] = useState(15);
  let [page_no,setpage_no] = useState(1);
  const message_index = 0;
  let [CURR_TOTAL_PAGE_NO,setCURR_TOTAL_PAGE_NO] = useState(1) ;
  let [BATCH_COUNT_COMPLETE,setBATCH_COUNT_COMPLETE] = useState(15);
  let [page_no_complete,setpage_no_complete] = useState(1);
  const message_index_complete = 0;
  let [CURR_TOTAL_PAGE_NO_COMPLETE,setCURR_TOTAL_PAGE_NO_COMPLETE] = useState(1) ;
  const [active, setactive] = useState(15);
  const [complete, setcomplete] = useState(15);


  useEffect(() => {
    get_batch_list_func();
  }, []);

  
  const handleSearchChange = (event) => {
    setSearchKey(event.target.value);
  };

  const enterKeyPress = (event,funct_trigg) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default form submission behavior
      if(funct_trigg == 'search_batch'){
        get_batch_list_func();
      }
    }
  };
  
  const get_batch_list_func = () => {
    setIsLoading(true); // Corrected line
    let payloadGBL = {
      batch_id: batch_id,
      search_key: searchKey,
      token: localStorage.getItem('vector_token'),
    };
    
    httpClient.post('/get_batch_list', payloadGBL)
      .then(response => {
        set_batch_list_data(response.data);
        setIsLoading(false); // Set loading to false after receiving response
      })
      .catch(error => {
        console.error('Error sending type ID:', error);
        setIsLoading(false); // Set loading to false in case of error
        // Handle error if needed
      });
  }
  

    function onPageSizeChange(pageSize){
      let temp_psize = pageSize.target.value;
      setBATCH_COUNT(temp_psize);
      setpage_no(1);
      onFixedMasterSearch(message_index,1,temp_psize);
    }  
  
    const on_click_row_button = (batch_task_id,type_id,name) => {
      navigate(`/Layout/BatchWorkflow?id=${batch_task_id}&batch_id=${batch_id}&name=${name}&si=${props.trigger_section_index}&ci=${props.trigger_comp_index}`);
    }

    function onPageForwRBACK(direction){
      if(direction === 'front' && page_no < CURR_TOTAL_PAGE_NO){
        onPageChange(null,page_no + 1);
      }else if(direction === 'back' && page_no > 1){
        onPageChange(null,page_no - 1);
      }else{
        props.triggerNotification('warning','Action not allowed!')
      }
    }

    function onPageChange(pageIndx,direct_val = null){
      let page_no = (direct_val !== null) ? direct_val : (pageIndx.target.value);
      setpage_no(page_no);
      onFixedMasterSearch(message_index,page_no);    
    }

    function onFixedMasterSearch(mess_indx, temp_page_no = null, temp_page_size = null) {
      try {
        let temp_BATCH_COUNT = temp_page_size ? temp_page_size : BATCH_COUNT;
        setactive(temp_BATCH_COUNT);
        let payload = {
          token: localStorage.getItem('vector_token'),
          batch_id: batch_id,
          search_key: "",
          completed_page_no: page_no_complete,
          active_page_no: temp_page_no ? temp_page_no : page_no,
          active_no_of_rows: temp_BATCH_COUNT,
          completed_no_of_rows: complete
        };
        setIsLoading(true);
        httpClient.post('/get_batch_list', payload)
          .then(response => {
            let resp = response.data;
            set_batch_list_data(response.data);
            if (resp["data"]) {
              let temp_pages = Math.floor(resp['data']['active_full_length']/ temp_BATCH_COUNT);
              if (resp['data']['active_full_length'] % temp_BATCH_COUNT !== 0) {
                temp_pages = temp_pages + 1;
              }
              setCURR_TOTAL_PAGE_NO(temp_pages);
              setIsLoading(false);

            } else {
            props.triggerNotification('warning', 'No data found');
            setIsLoading(false);

            }
          })
          .catch(error => {
            console.error(' Error:', error);
            props.triggerNotification('error', 'An error occurred while fetching data');
          });
      } catch (error) {
        console.error(' Error:', error);
        props.triggerNotification('error', 'An error occurred');
      }
    }

    function onPageSizeChangecomplete(pageSize){
      let temp_psize = pageSize.target.value;
      setBATCH_COUNT_COMPLETE(temp_psize);
      setpage_no_complete(1);
      onFixedMasterSearchcomplete(message_index_complete,1,temp_psize);
    }  

    
    function onPageForwRBACKcomplete(direction){
      if(direction === 'front' && page_no_complete< CURR_TOTAL_PAGE_NO_COMPLETE){
        onPageChangecomplete(null,page_no_complete + 1);
      }else if(direction === 'back' && page_no_complete > 1){
        onPageChangecomplete(null,page_no_complete - 1);
      }else{
        props.triggerNotification('warning','Action not allowed!')
      }
    }

    function onPageChangecomplete(pageIndx,direct_val = null){
      let page_no = (direct_val !== null) ? direct_val : (pageIndx.target.value);
      setpage_no_complete(page_no);
      onFixedMasterSearchcomplete(message_index_complete,page_no);    
    }

    function onFixedMasterSearchcomplete(mess_indx, temp_page_no = null, temp_page_size = null) {
      try {
        let temp_BATCH_COUNT_COMPLETE = temp_page_size ? temp_page_size : BATCH_COUNT_COMPLETE;
        setcomplete(temp_BATCH_COUNT_COMPLETE)
        let payload = {
          token: localStorage.getItem('vector_token'),
          batch_id: batch_id,
          search_key: "",
          completed_page_no: temp_page_no ? temp_page_no : page_no_complete,
          active_page_no: page_no,
          active_no_of_rows: active,
          completed_no_of_rows: temp_BATCH_COUNT_COMPLETE
        };
        setIsLoading(true);
        httpClient.post('/get_batch_list', payload)
          .then(response => {
            let resp = response.data;
            set_batch_list_data(response.data);
            if (resp["data"]) {
              let temp_pages = Math.floor(resp['data']['completed_full_length']/ temp_BATCH_COUNT_COMPLETE);
              if (resp['data']['completed_full_length'] % temp_BATCH_COUNT_COMPLETE !== 0) {
                temp_pages = temp_pages + 1;
              }
              setCURR_TOTAL_PAGE_NO_COMPLETE(temp_pages);
              setIsLoading(false);
            } else {
            props.triggerNotification('warning', 'No data found');
            setIsLoading(false);
            }
          })
          .catch(error => {
            console.error(' Error:', error);
            props.triggerNotification('error', 'An error occurred while fetching data');
          });
      } catch (error) {
        console.error(' Error:', error);
        props.triggerNotification('error', 'An error occurred');
      }
    }

    function BatchTasksTable({ tasks, headers, status }) {
      if (!tasks || tasks.length === 0 || !headers || headers.length === 0) {
        return <div id="no_datas"><p id="no_data">No batch available</p></div>
        
      }
    
      return (
        <div>
        {isLoading ? (<LinearProgress/>) : null}
        <div className='scroll_x_div'>
          <div className="resp_outer_horiz">
            <div className="Table_Content">
              <div id="resp-table">
                <div id="resp-table-header">
                  <div className="table-header-cell">
                    <div className='resp-table-cell-content'>Batch Task Name</div>
                  </div>
                  <div className="table-header-cell">
                    <div className='resp-table-cell-content'>Created User</div>
                  </div>
                  <div className="table-header-cell">
                    <div className='resp-table-cell-content'>Created Time</div>
                  </div>
                  {headers.map((header, index) => (
                   header !== 'batch task id' && header !== 'Batch' && header !== 'Created By' && header !== 'Created Time' && (
                      <div key={index} className="table-header-cell">
                        <div className='resp-table-cell-content' style={{textTransform:'capitalize'}}>{header}</div>
                      </div>
                    )
                  ))}
                  <div className="table-header-cell">
                    <div className='resp-table-cell-content'>Action</div>
                  </div>
                </div>
                <div id="resp-table-body">
                  {tasks.map((task, index) => (
                    <div key={index} className="resp-table-row">
                      <div className="table-body-cell">
                        <div className='resp-table-cell-content'>{task['Batch']}</div>
                      </div>
                      <div className="table-body-cell">
                        <div className='resp-table-cell-content'>{task['Created By']}</div>
                      </div>
                      <div className="table-body-cell">
                        <div className='resp-table-cell-content'>{task['Created Time']}</div>
                      </div>
                      {Object.keys(task).map((key, idx) => (
                        key !== 'batch task id' && key !== 'Batch' && key !== 'Created By' && key !== 'Created Time' && (
                          <div key={idx} className="table-body-cell">
                            <div className='resp-table-cell-content'>{task[key]}</div>
                          </div>
                        )
                      ))}
                      <div className="table-body-cell">
                        <div className='resp-table-cell-content'>
                          {status === "Active" ? (
                          <Button onClick={() => on_click_row_button(task['batch task id'], type_id, task['Batch'])} title="Submit" sx={{backgroundColor: '#00AAFF', borderRadius: '45px', height: "20", color: 'white', '&:hover': { backgroundColor: 'white', color: 'black', border: '1px solid #00AAFF', } }}>
                            <ArrowRightAltIcon/>     
                          </Button>
                          ) : (
                            <>
                              <img src={tick} alt="Button Image" className='tick-tab-button' /> 
                              <span > Done</span>
                              {/* <div className='hidedActionbutton'>
                                <Button  onClick={() => on_click_row_button(task['batch task id'], type_id, task['Batch'])} title="Submit" sx={{backgroundColor: '#00AAFF', borderRadius: '45px', height: "20", color: 'white', '&:hover': { backgroundColor: 'white', color: 'black', border: '1px solid #00AAFF', } }}>
                                <img src={tick} alt="Button Image" className='tick-tab-button' /> <span sx={{backgroundColor: '#00AAFF', borderRadius: '45px', height: "20", color: 'white' }}> Done</span>  <ArrowRightAltIcon/>    
                                </Button>
                              </div> */}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    )}
  
    if (!batch_list_data) {
      return  <>
        <h2 className="batch-workflow">Active Batches</h2>
      <Stack spacing={1}>
        <Skeleton
          sx={{ backgroundColor: 'rgba(147 138 138 / 55%)' }}
          animation="wave" />
        <Skeleton 
          sx={{ backgroundColor: 'rgba(147 138 138 / 55%)' }}
          animation="wave" />
        <Skeleton 
          sx={{ backgroundColor: 'rgba(147 138 138 / 55%)' }}
          animation="wave" />
      </Stack>
      <h2 className="batch-workflow">Completed Batches</h2>
      <Stack spacing={1}>
        <Skeleton
          sx={{ backgroundColor: 'rgba(147 138 138 / 55%)' }}
          animation="wave" />
        <Skeleton 
          sx={{ backgroundColor: 'rgba(147 138 138 / 55%)' }}
          animation="wave" />
        <Skeleton 
          sx={{ backgroundColor: 'rgba(147 138 138 / 55%)' }}
          animation="wave" />
      </Stack>
    </> 
    }
    const activeHeaders = batch_list_data.data.active?.[0] ? Object.keys(batch_list_data.data.active[0]) : [];
    const completeHeaders = batch_list_data.data.completed?.[0] ? Object.keys(batch_list_data.data.completed[0]) : [];
  
    return (
      <div>
        <div className='alingItem'>

              <Grid container spacing={{ xs: 2, md: 2 }} columns={{ xs: 4, sm: 8, md: 13 }}>
                <Grid item xs={3}>
                  <div className='sectionName'>
                    Select a Batch
                  </div>
                </Grid>
                <Grid item xs={9}>
                  <div style={{ float: 'left' }}>
                    <Paper
                      component="form"
                      sx={{ display: 'flex', alignItems: 'center', width: '240px', borderRadius: '184px', height: '25px', padding: '4px 6px 4px 12px', backgroundColor: '#E5F6FF' }}
                    >
                      <InputBase
                        sx={{ ml: 0, flex: 1, pl: 0, fontSize: '12px' }}
                        placeholder="Search a record"
                        value={searchKey}
                        onChange={handleSearchChange}
                        onKeyDown={(e) => enterKeyPress(e,'search_batch')}
                      />
                      <IconButton type="button" sx={{ p: '2px', width: '40px', height: '40px', borderRadius: '50%' }} aria-label="search" onClick={() => get_batch_list_func()}>
                        <SearchIcon sx={{ width: '20px', height: '20px' }} />
                      </IconButton>
                    </Paper>
                  </div>
                </Grid>
              </Grid>

        </div>
        <div style={{width: "100%"}} >
          <div style={{display:'inline-block',width: "50%",textAlign: "left"}}>
            <span className="batch-workflow">Active Batches</span>
          </div>
          <div style={{display:'inline-block',width: "50%"}}>
            <div style={{  alignItems: 'center' ,float: 'right'}}>
              <Grid container spacing={{ xs: 2, md: 2 }} columns={{ xs: 4, sm: 8, md: 13 }}>
                <Grid item xs={2} >
                  <Button variant="text" sx={{ color: '#4D4D4D', minWidth: '20px' }} onClick={() => onPageForwRBACK("back")} disabled={page_no === 1}>
                    <ArrowBackIosOutlinedIcon sx={{ width: '15px' }} />
                  </Button>
                </Grid>
                <Grid item xs={3} >
                  <Select
                    value={page_no}
                    onChange={(e) => onPageChange(e)}
                    sx={{ color: '#4D4D4D', height: '35px', borderRadius: '10px', backgroundColor: 'white' }}
                    autoWidth
                    size='small'
                  >
                    {Array.from({ length: CURR_TOTAL_PAGE_NO }, (_, index) => (
                      <MenuItem key={index + 1} value={index + 1}>
                        {index + 1}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
                <Grid item xs={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center',color:'#4D4D4D',fontSize:'20px' }}>
                    <span style={{ verticalAlign: 'middle', position: 'relative', top: '-2px' }}> / {CURR_TOTAL_PAGE_NO}</span>
                </Grid>
                <Grid item xs={2} >
                  <Button sx={{ color: '#4D4D4D', minWidth: '20px' }} onClick={() => onPageForwRBACK("front")} disabled={page_no === CURR_TOTAL_PAGE_NO}>
                    <ArrowForwardIosOutlinedIcon sx={{ width: '15px' }} />
                  </Button>
                </Grid>
                
                <Grid item xs={3}>
                  <Select
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    value={BATCH_COUNT}
                    onChange={(e) => onPageSizeChange(e)}
                    size='small'
                    sx={{ color: '#4D4D4D', height: '35px', borderRadius: '10px', backgroundColor: 'white' }}
                  >
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                    <MenuItem value={100}>100</MenuItem>
                  </Select>
                </Grid>
              </Grid>
            </div>
          </div>
        </div>

        <BatchTasksTable tasks={batch_list_data.data.active} headers={activeHeaders} status="Active" />
        <div style={{ display: 'flex', alignItems: 'center'}}>
          <h2 className="batch-workflow">Completed Batches</h2>
          <div style={{ display: 'flex', alignItems: 'center',marginLeft:'65%' }}>
            <Button variant="text" sx={{ color: '#4D4D4D', minWidth: '20px' }} onClick={() => onPageForwRBACKcomplete("back")} disabled={page_no_complete === 1}>
              <ArrowBackIosOutlinedIcon sx={{ width: '15px' }} />
            </Button>
            <Select
              value={page_no_complete}
              onChange={(e) => onPageChangecomplete(e)}
              sx={{ color: '#4D4D4D', height: '35px', borderRadius: '10px', backgroundColor: 'white', marginLeft: '5px' }}
              autoWidth
              size='small'
            >
              {Array.from({ length: CURR_TOTAL_PAGE_NO_COMPLETE }, (_, index) => (
                <MenuItem key={index + 1} value={index + 1}>
                  {index + 1}
                </MenuItem>
              ))}
            </Select>
            <div style={{ display: 'flex', alignItems: 'center', color: '#4D4D4D', fontSize: '20px', marginLeft: '5px' }}>
              <span style={{ verticalAlign: 'middle', position: 'relative', top: '-2px' }}>/ {CURR_TOTAL_PAGE_NO_COMPLETE}</span>
            </div>
            <Button sx={{ color: '#4D4D4D', minWidth: '20px', marginLeft: '5px' }} onClick={() => onPageForwRBACKcomplete("front")} disabled={page_no === CURR_TOTAL_PAGE_NO_COMPLETE}>
              <ArrowForwardIosOutlinedIcon sx={{ width: '15px' }} />
            </Button>
            <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              value={BATCH_COUNT_COMPLETE}
              onChange={(e) => onPageSizeChangecomplete(e)}
              size='small'
              sx={{ color: '#4D4D4D', height: '35px', borderRadius: '10px', backgroundColor: 'white', marginLeft: '5px' }}
            >
              <MenuItem value={15}>15</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </div>
        </div>

        <BatchTasksTable tasks={batch_list_data.data.completed} headers={completeHeaders} status="Completed" />
    </div>
  );
}

Batch.propTypes = {};

Batch.defaultProps = {};

export default Batch;
